"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthorizationForwarder = void 0;
var AuthorizationForwarder_1 = require("./AuthorizationForwarder");
Object.defineProperty(exports, "AuthorizationForwarder", { enumerable: true, get: function () { return AuthorizationForwarder_1.AuthorizationForwarder; } });
